// extracted by mini-css-extract-plugin
export var closed = "_i2-1";
export var resizer = "_i2-0";